import { PostSearch, PostSearchFilters, QueryResult } from '@/type';
import api from '../../API';

export default {
  find(id: number): Promise<PostSearch> {
    return api
      .get(`post-searches/${id}`)
      .then(response => response.data);
  },
  findAll(clientId: number, filters: PostSearchFilters): Promise<QueryResult<PostSearch>> {
    return api
      .get(`clients/${clientId}/post-searches`, { params: filters })
      .then(response => response.data);
  },
};
